// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"bR0ib__listWrap","listItem":"_1Id5r__listItem theme-accent-link","listItemText":"_3fz-P__listItemText"};